module.exports = __webpack_public_path__ + "img/1537884552.f869dc65.jpg";